import theme from './theme';
const boxShadow = (props)=>theme(props).boxShadow;
export const boxShadowNone = (props)=>boxShadow(props).none;
export const boxShadowStandard = (props)=>boxShadow(props).standard;
const borderRadius = (props)=>theme(props).borderRadius;
export const borderRadiusNone = (props)=>borderRadius(props).none;
export const borderRadiusSmall = (props)=>borderRadius(props).small;
export const borderRadiusStandard = (props)=>borderRadius(props).standard;
export const borderRadiusFull = (props)=>borderRadius(props).full;

//# sourceMappingURL=common.js.map